import PropTypes from 'prop-types';
import React from 'react';
import S from 'styles/form.scss';
import cx from 'classnames';
import styles from 'styles/input.scss';
import Signature from 'react-signature-canvas';

const SignatureBox = ({ label, value, onClear, className, errors, onEnd, ...props }) => {
  const errorMsg = errors.join(', ');
  const wrapperStyles = cx(className, S.formElementContainer, { [styles.errored]: errorMsg });
  const textAreaStyles = cx(styles.inputElement, S.inputArea, S.signature);
  const labelStyles = errorMsg ? cx(S.label, S.errorLabel) : S.label;
  let sigPad = {};

  return (

    <div className={wrapperStyles} >
      <h6 className={labelStyles}>{label}</h6>
      <div className={S.inputActions}>
        <button
          onClick={() => {
            onClear();
            sigPad.clear();
          }}
        >
          Clear
        </button>
      </div>

      {value &&
        <img src={value} alt="Signature" />
      }

      {!value &&
        <div className={textAreaStyles}>
          <Signature
            // canvasProps passes props directly to the canvas element.
            canvasProps={{ className: styles.sigPad }}
            /**
             * Storing the ref in the sigPad object. This is required to
             * be able to call the methods on the canvas
             */
            ref={(ref) => { sigPad = ref; }}
            /**
             * We need to bubble up the image created by sigPad, or else
             * the parent component receives the mouse events triggered
             * by the canvas instead.
             */
            onEnd={() => {
              /**
               * When signing on a mobile device the image is much
               * larger than on a desktop. To get the signature to
               * be consistently the same size we need to check for
               * the width of the window, and if larger than a 800px
               * we need to resize that image. Since we save the image
               * as a base64 to store it in state as a string, we need
               * to use another canvas to resize the image when on a
               * desktop.
               */
              if (window.innerWidth > 900) {
                // New canvas that will increase the image size
                const resizedCanvas = document.createElement('canvas');
                const resizedContext = resizedCanvas.getContext('2d');
                // Through testing triple the size of the image on mobile
                // seems to be the best size for consistently saving images
                const tripleCanvasWidth = sigPad.getCanvas().width * 3;
                const tripleCanvasHeight = sigPad.getCanvas().height * 3;

                resizedCanvas.width = tripleCanvasWidth;
                resizedCanvas.height = tripleCanvasHeight;
                resizedContext.drawImage(
                  sigPad.getCanvas(), // Current signature in the canvas
                  0, 0, // X and Y coordinates of the origin
                  tripleCanvasWidth,
                  tripleCanvasHeight,
                );

                const myResizedData = resizedCanvas.toDataURL('image/png');
                onEnd(myResizedData);
              } else { // using mobile device
                onEnd(sigPad.getTrimmedCanvas().toDataURL('image/png'));
              }
            }}
            clearOnResize={false}
            {...props}
          />
        </div>
      }

      {errorMsg &&
        <div className={styles.error}>
          <p className={S.errorMsg}>{errorMsg}</p>
        </div>
      }
    </div>
  );
};

SignatureBox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onEnd: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
  className: PropTypes.string,
};

SignatureBox.defaultProps = {
  label: '',
  text: '',
  errors: [],
};

export default SignatureBox;



// WEBPACK FOOTER //
// ./client/app/shared/components/SignatureBox/index.jsx